import { ParsedQuery } from 'query-string'

/**
 * The legacy model is gone; the new model is always in use. The hook is kept
 * so call sites don't churn.
 */
export const useNewModel = (_parsedQuery?: ParsedQuery<string>): boolean => {
  return true
}
